const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const LOGIN_URL = `${BASE_URL}/api/Auth/login`;
export const RESOURCE_DETAILS_URL = `${BASE_URL}/api/Resources/AccountDetails`;
export const CREATE_EDIT_RESOURCE_URL = `${BASE_URL}/api/Resources/SaveAccountDetails`;
export const FETCH_RESOURCES_LIST = `${BASE_URL}/api/Resources/AccountList`;
export const FETCH_ACCOUNTS_BY_QUERY_URL = `${BASE_URL}/api/Resources/ResourcesDropdown`;
export const RESET_PASS_URL = `${BASE_URL}/api/Auth/SetPassword`;
export const FORGOT_PASS_URL = `${BASE_URL}/api/Auth/ForgotPassword`;
export const CHANGE_PASS_URL = `${BASE_URL}/api/Resources/ChangePassword`;
export const CREATE_PROJECT_URL = `${BASE_URL}/api/Projects/SaveProjectDetails`;
export const DELETE_PROJECT_ATTACHMENT = `${BASE_URL}/api/Projects/DeleteAttachment`;
export const DELETE_PROJECT_ENGAGEMENT = `${BASE_URL}/api/Projects/DeleteProjects`;
export const SAVE_PROJECT_TASKS = `${BASE_URL}/api/ProjectTasks/SaveProjectTaskDetails`;
export const DELETE_PROJECT_TASKS = `${BASE_URL}/api/ProjectTasks/DeleteProjectTasks`;
export const FETCH_PROJECT_TASKS = `${BASE_URL}/api/ProjectTasks/ProjectTasksList`;
export const GET_HOLIDAY_LIST_FOR_WEEK = `${BASE_URL}/api/Holidays/GetHolidaysByRange`;
export const GET_HOLIDAY_LIST = `${BASE_URL}/api/Holidays/HolidaysList`;
export const DELETE_HOLIDAY = `${BASE_URL}/api/Holidays/DeleteHolidays`;
export const SAVE_HOLIDAYS = `${BASE_URL}/api/Holidays/SaveHolidayDetails`;
export const FETCH_PROJECTS_LIST = `${BASE_URL}/api/Projects/ProjectsList`;
export const FETCH_REPORTS_LIST = `${BASE_URL}/api/Reports/GetReportsList`;
export const FETCH_FILE_DATA = `${BASE_URL}/api/Reports/GetFile`;
export const FETCH_RESOURCE_PROJECTS = `${BASE_URL}/api/Projects/ProjectsByResource`;
export const FETCH_PROJECT_DETAILS = `${BASE_URL}/api/Projects/ProjectDetails`;
export const UPDATE_PROJECT_URL = `${BASE_URL}/api/Projects/UpdateProjectDetails`;
export const BULK_UPDATE_RESOURCE_STATUS_URL = `${BASE_URL}/api/Resources/ChangeResourceStatus`;
export const BULK_DELETE_RESOURCES_URL = `${BASE_URL}/api/Resources/DeleteResources`;
export const SUBMIT_TIME_SHEET = `${BASE_URL}/api/Timesheet/SubmitTimesheet`;
export const FETCH_TIMESHEET_BY_ID = `${BASE_URL}/api/Timesheet/GetTimesheetDetailsByID`;
export const APPROVE_OR_REJECT_TIMESHEET = `${BASE_URL}/api/Timesheet/Approvals`;
export const DELETE_TIMESHEET_ATTACHMENT = `${BASE_URL}/api/Timesheet/DeleteTimesheetAttachment`;
export const GET_APPROVAL_LIST = `${BASE_URL}/api/Timesheet/TimesheetApprovalList`;
export const UPDATE_TIME_SHEET = `${BASE_URL}/api/Timesheet/UpdateTimesheet`;
export const GET_SAVED_TIMESHEETS_INFO = `${BASE_URL}/api/Timesheet/GetTimesheetDetailsByProject`;
export const GET_EMPLOYEE_DASHBOARD_EVENTS = `${BASE_URL}/api/Dashoboard/EmployeeDashboard`;
export const GET_ADMIN_WEEKLY_REPORT = `${BASE_URL}/api/Dashoboard/AdminDashboardExcel`;
export const ADMIN_DASHBOARD_INFO = `${BASE_URL}/api/Dashoboard/AdminDashboard`;
export const GET_EMPLOYEE_MONTHLY_STATS = `${BASE_URL}/api/Dashoboard/EmployeeDashboardHours`;
export const NOTIFICATIONS_LIST = `${BASE_URL}/api/Notifications/NotificationsList`;
export const CLEAR_NOTIFICATIONS = `${BASE_URL}/api/Notifications/ClearNotifications`;
export const MARKASREAD_NOTIFICATIONS = `${BASE_URL}/api/Notifications/MarkNotificationsAsRead`;
